export default {
  setStates(state, payload) {
    state.states = payload;
  },
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },
  setPaginationProperty(state, { payload }) {
    state.pagination = payload;
  },
  setCountries(state, payload) {
    state.countries = payload;
  },
};
